import type { InjectionKey } from 'vue';

/** A specific nested target takes priority over its surrounding upload area. */
export interface FileDropTargetContext {
  claim: (target: symbol) => void;
  release: (target: symbol) => void;
}

export const fileDropTargetContext: InjectionKey<FileDropTargetContext> =
  Symbol('nx-file-drop-target');
